{
  "title": "Service Providers",
  "description": "Manage your service providers and their information",
  "addProvider": "Add Provider",
  "searchPlaceholder": "Search providers...",
  "deleteTitle": "Delete provider",
  "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
  "deleteDescriptionGeneric": "Are you sure you want to delete this provider? This action cannot be undone.",
  "deleted": "Provider deleted successfully",
  "deleteError": "Failed to delete provider",
  "form": {
    "createTitle": "Create Provider",
    "createDescription": "Add a new service provider to your team",
    "editTitle": "Edit Provider",
    "editDescription": "Update provider information",
    "cardTitle": "Provider Information",
    "cardDescription": "Enter the details for the new provider",
    "editCardDescription": "Update the provider details",
    "image": "Provider Image",
    "imageHint": "Upload a profile image for the provider",
    "uploading": "Uploading...",
    "uploadFailed": "Upload failed",
    "name": "Name",
    "nameHint": "Provider's full name",
    "namePlaceholder": "Enter provider name",
    "email": "Email",
    "emailHint": "Provider's email address",
    "emailPlaceholder": "Enter email address",
    "creating": "Creating...",
    "updating": "Updating...",
    "saveCreate": "Create Provider",
    "saveUpdate": "Update Provider",
    "nameRequired": "Provider name is required",
    "emailRequired": "Email is required",
    "invalidEmail": "Invalid email",
    "noBusiness": "Select a business before adding a provider",
    "noBusinessId": "Business ID not found",
    "created": "Provider created successfully",
    "createError": "Failed to create provider",
    "updated": "Provider updated successfully",
    "updateError": "Failed to update provider",
    "notFoundTitle": "Provider Not Found",
    "notFoundDescription": "The provider you are trying to edit could not be found.",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "editImageHint": "Upload a new profile image for the provider"
  },
  "show": {
    "title": "Provider Details",
    "documentTitle": "{{name}} | Providers",
    "documentTitleFallback": "Provider Details",
    "emailDescription": "Email: {{email}}",
    "actions": "Actions",
    "editProvider": "Edit Provider",
    "deleteProvider": "Delete Provider",
    "notFoundTitle": "Provider Not Found",
    "notFoundDescription": "The provider you are looking for could not be found.",
    "loadFailed": "Failed to load provider",
    "backToProviders": "Back to Providers",
    "profileImage": "Profile Image",
    "name": "Name",
    "email": "Email",
    "assignedUnits": "Assigned Units",
    "unitsCount": "{{count}} unit",
    "unitsCount_other": "{{count}} units",
    "notAssignedUnits": "Not assigned to any units",
    "assignedServices": "Assigned Services",
    "assignedServiceUnits": "Assigned Service Units",
    "unnamedService": "Unnamed Service",
    "unnamedUnit": "Unnamed Unit",
    "unitsForService": "{{count}} unit(s)",
    "serviceLabel": "Service: {{name}}",
    "unknownService": "Unknown",
    "viewService": "View Service",
    "noAssignments": "This provider is not assigned to any service units yet."
  }
}
